import styled from 'styled-components';

const HeaderStyle = styled.header`
	--headerPadTB: var(--sp4x);
	/* --headerPadLR: var(--sp6x); */
	--headerPadLR: var(--sp20x);
	--headerLogoWidth: var(--sp22x);
	--headerLogoHeight: var(--sp8x);
	--menuItemsGap: var(--sp4x);
	--dropdownItemGap: var(--sp1x);
	--rightItemsGap: var(--sp3x);
	--searchIconSize: var(--sp3x);

	--desktopDropdownItemBorderRadius: 6px;
	--desktopDropdownItemPad: var(--sp1x);
	--desktopDropdownPad: var(--sp4x);
	--desktopDropdownItemsGap: var(--sp4x);
	--desktopDropdownBorderRadius: var(--sp1-5x);
	--desktopDropdownItemFixedWidth: var(--sp38x);

	--customPadTB: var(--sp2x);
	--customPadLR: var(--sp5x);

	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	padding: var(--headerPadTB) var(--contPaddingLR);
	background-color: var(--white1000);
	z-index: 99;

	${(props) => (props.$firstLoad ? `transform: translateY(-100%);` : null)}

	.header-inner-wrapper {
		display: grid;
		grid-template-columns: 1fr auto 1fr;
		gap: var(--gutter);
	}

	.header-logo-block {
		z-index: 11;

		svg {
			width: var(--headerLogoWidth);
			height: var(--headerLogoHeight);
		}
	}

	.menubar-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.menubar-inner-wrapper {
		display: flex;
		align-items: center;
		gap: var(--menuItemsGap);
	}

	.route-inner-item {
		display: flex;
		align-items: center;
		gap: var(--dropdownItemGap);
	}

	.route-icon {
		font-size: 14px;

		will-change: transform;
		transition: transform var(--trTime) ease-out;
	}

	.header-right-block {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: var(--rightItemsGap);
	}
	.search-icon-wrapper {
		display: flex;
	}
	.search-icon {
		z-index: 11;
		font-size: var(--searchIconSize);
	}

	.desktop-dropdown-items-wrapper {
		position: absolute;
		top: calc(100% - var(--headerPadTB));
		padding: var(--desktopDropdownPad);
		transform: translateX(calc((var(--desktopDropdownPad)) * -1));
		border-radius: var(--desktopDropdownBorderRadius);
		overflow: hidden;
		background-color: var(--white1000);
		border: 1px solid var(--gray100);

		pointer-events: none;
		user-select: none;
		will-change: opacity;
		opacity: 0;
		transition: opacity 0.1s ease-out;
	}

	.desktop-dropdown-items-inner-wrapper {
		display: flex;
		gap: var(--desktopDropdownItemsGap);
	}

	.children-group {
		display: flex;
		flex-direction: column;
		gap: calc(var(--desktopDropdownItemsGap) - var(--desktopDropdownItemPad));
		flex: 1;
	}

	.desktop-item-link {
		position: relative;
		width: var(--desktopDropdownItemFixedWidth);

		.desktop-item-title {
			transition: color var(--trTime) ease-out;
		}

		&:before {
			content: '';
			position: absolute;
			left: calc(-1 * var(--desktopDropdownItemPad));
			width: calc(100% + var(--desktopDropdownItemPad) * 2);
			height: 100%;
			border-radius: var(--desktopDropdownItemBorderRadius);
			overflow: hidden;
			transition: background-color var(--trTime) ease-out;
		}

		&.active {
			pointer-events: none;
			cursor: default;

			.desktop-item-title {
				color: var(--red1000);
			}
		}
	}

	.route-link {
		.route-title {
			transition: color var(--trTime) ease-out;
		}

		&.active {
			pointer-events: none;
			cursor: default;

			.route-title {
				color: var(--red1000) !important;
			}
		}
	}

	.desktop-item-title {
		position: relative;
		padding: var(--desktopDropdownItemPad) 0;
		/* white-space: nowrap; */
		font-size: var(--header_open);
		line-height: var(--lineHeightL);
		z-index: 11;
	}

	.dropdown-variant {
		.route-inner-item {
			position: relative;

			&:before {
				content: '';
				position: absolute;
				top: 100%;
				width: 100%;
				height: 100%;
				display: none;
				z-index: 11;
			}
		}
	}

	/* //! Hover effect with JS */
	.route-item {
		transition: opacity 0.3s ease-out;

		&.before-hovered,
		&.after-hovered {
			opacity: 0.5;
		}

		&.active {
			opacity: 1;
		}
	}

	&:not(&.background-variant) {
		&.transparent-variant {
			background-color: transparent;

			.header-logo-block {
				svg {
					path {
						fill: var(--white1000);
						stroke: var(--white1000);
					}
				}
			}

			.route-title,
			.route-icon,
			.selected-lang,
			.selected-lang-icon,
			.search-icon {
				color: var(--white1000);
			}

			.contact-btn-block {
				.btn {
					a,
					button {
						color: var(--white1000);
						border: 1px solid var(--white1000);
					}
				}
			}
		}
	}

	&:not(&.background-variant).black-variant {
		background-color: var(--black1000);
	}

	/* //! Hover */
	@media (pointer: fine) {
		@media (hover: hover) {
			.dropdown-variant {
				&:hover {
					.desktop-dropdown-items-wrapper {
						opacity: 1;
						pointer-events: all;
					}

					.route-icon {
						transform: rotate(180deg);
					}

					.route-inner-item {
						&:before {
							display: block;
						}
					}
				}
			}

			.desktop-item-link {
				&:hover {
					&:before {
						background-color: var(--gray100);
					}
				}
			}
		}
	}

	.contact-btn-block {
		.btn {
			&.secondary-transparent {
				a,
				button {
					font-size: var(--p2) !important;
					line-height: var(--lineHeightL) !important;
					padding: var(--customPadTB) var(--customPadLR) !important;
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--headerPadTB: var(--sp4x);
		/* --headerPadLR: var(--sp4x); */
		--headerPadLR: var(--sp8x);
		--headerLogoWidth: var(--sp19x);
		--headerLogoHeight: var(--sp7x);
		--menuItemsGap: var(--sp4x);
		--dropdownItemGap: var(--sp1x);
		--rightItemsGap: var(--sp3x);

		--desktopDropdownPad: var(--sp3x);
		--desktopDropdownItemsGap: var(--sp3x);
		--desktopDropdownItemFixedWidth: var(--sp29x);

		--customPadTB: 14px;
		--customPadLR: var(--sp4x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--headerPadTB: var(--sp3x);
		--headerPadLR: var(--sp4x);
		--headerLogoWidth: var(--sp17x);
		--headerLogoHeight: var(--sp6x);
		--menuItemsGap: var(--sp3x);
		--dropdownItemGap: var(--sp1x);
		--rightItemsGap: var(--sp2x);
		--searchIconSize: var(--sp2-5x);

		--desktopDropdownItemFixedWidth: var(--sp25x);

		--customPadTB: var(--sp1-5x);
		--customPadLR: var(--sp3x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--headerPadTB: var(--sp2-5x);
		--headerLogoWidth: var(--sp17x);
		--headerLogoHeight: var(--sp6x);
		--menuItemsGap: var(--sp2-5x);
		--dropdownItemGap: var(--sp0-5x);
		--rightItemsGap: var(--sp2x);

		--desktopDropdownPad: var(--sp2-5x);
		--desktopDropdownItemsGap: var(--sp2-5x);
		--desktopDropdownItemFixedWidth: var(--sp23x);

		--customPadTB: var(--sp1-5x);
		--customPadLR: var(--sp3x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--headerPadTB: var(--sp2x);
		--headerPadLR: var(--sp3x);
		--headerLogoWidth: var(--sp13x);
		--headerLogoHeight: var(--sp5x);
		--menuItemsGap: var(--sp2x);
		--dropdownItemGap: var(--sp0-5x);
		--rightItemsGap: var(--sp1-5x);

		--desktopDropdownPad: var(--sp2x);
		--desktopDropdownItemFixedWidth: var(--sp23x);

		--customPadTB: var(--sp1-5x);
		--customPadLR: var(--sp3x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--headerPadTB: var(--sp2x);
		--headerLogoWidth: var(--sp13x);
		--headerLogoHeight: var(--sp5x);
		--menuItemsGap: var(--sp2x);
		--dropdownItemGap: var(--sp0-5x);
		--rightItemsGap: var(--sp1-5x);

		/* //! Burger menu styles values */
		--burgerMenuPadTB: var(--sp5x);
		--burgerMenuItemsGap: var(--sp3x);
		--burgerMenuChildrenMTop: var(--sp2x);

		--burgerMenuChildrenRowGap: var(--sp1x);
		--burgerMenuChildrenColumnGap: var(--sp3x);
		--burgerMenuChildGridSize: 1fr 1fr 1fr;

		--globusSVGBottom: -36%;
		--globusSVGRight: -19%;
		--globusSVGHeight: 100%;

		--customPadTB: unset;
		--customPadLR: unset;

		.globus-svg {
			position: fixed;
			bottom: var(--globusSVGBottom);
			right: var(--globusSVGRight);
			width: 100vw;
			height: var(--globusSVGHeight);
			z-index: -1;
		}

		.header-inner-wrapper {
			grid-template-columns: 1fr 1fr;
		}

		.menubar-wrapper {
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100dvh;
			justify-content: flex-start;
			padding: calc(var(--burgerMenuPadTB) + var(--headerFixedHeight)) var(--contPaddingLR) var(--burgerMenuPadTB);
			background-color: var(--white1000);
			z-index: 9;

			will-change: transform;
			transform: translate3d(100%, 0, 0);
			transition: transform var(--trTime) ease-out;

			&.active {
				transform: translate3d(0, 0, 0);
			}
		}

		.menubar-inner-wrapper {
			flex-direction: column;
			align-items: flex-start;

			overflow: hidden auto;
			-ms-overflow-style: none; /* IE and Edge */
			scrollbar-width: none; /* Firefox */

			&::-webkit-scrollbar {
				display: none;
			}
		}

		#collapse-container {
			width: 100%;
			display: flex;
			flex-direction: column;
			gap: var(--burgerMenuItemsGap);
		}

		.dropdown-mobile-variant {
			.route-inner-mobile-item {
				display: block;

				.wrapper-title-button {
					display: flex;
					align-items: center;
					justify-content: space-between;
					gap: var(--sp2x);

					svg {
						width: 14px;
						height: 14px;
						transition: transform var(--trTime) ease-out;
					}
				}
			}
		}

		.dropdown-mobile-wrapper {
			display: grid;
			grid-template-columns: var(--burgerMenuChildGridSize);
			row-gap: var(--burgerMenuChildrenRowGap);
			column-gap: var(--burgerMenuChildrenColumnGap);

			margin-top: var(--burgerMenuChildrenMTop);
		}

		.item-mobile-link {
			width: fit-content;
		}

		#collapse-item {
			&.active {
				svg {
					transform: rotate(180deg);
				}
			}
		}

		/* //! For Burger Menu */
		.route-mobile-title {
			font-size: 18px;
		}

		.item-mobile-title {
			font-size: 14px;
		}

		.route-mobile-link {
			.route-mobile-title {
				transition: color var(--trTime) ease-out;
			}

			&.active {
				pointer-events: none;
				cursor: default;

				.route-mobile-title {
					color: var(--red1000);
				}
			}
		}

		.item-mobile-link {
			.item-mobile-title {
				transition: color var(--trTime) ease-out;
			}

			&.active {
				pointer-events: none;
				cursor: default;

				.item-mobile-title {
					color: var(--red1000);
				}
			}
		}

		.contact-btn-block {
			display: none;
			pointer-events: none;
			cursor: default;
		}
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--headerPadTB: var(--sp2x);
		--headerPadLR: var(--sp2x);
		--headerLogoWidth: var(--sp11x);
		--headerLogoHeight: var(--sp4x);
		--menuItemsGap: var(--sp2x);
		--dropdownItemGap: var(--sp0-5x);
		--rightItemsGap: var(--sp1-5x);

		/* //! Burger menu styles values */
		--burgerMenuPadTB: var(--sp4x);

		--globusSVGBottom: 0;
		--globusSVGRight: -17%;
		--globusSVGHeight: 63%;

		--customPadTB: unset;
		--customPadLR: var(--sp3x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--headerPadTB: var(--sp2x);
		--headerLogoWidth: var(--sp11x);
		--headerLogoHeight: var(--sp4x);
		--menuItemsGap: var(--sp2x);
		--dropdownItemGap: var(--sp0-5x);
		--rightItemsGap: var(--sp1-5x);

		/* //! Burger menu styles values */
		--burgerMenuPadTB: var(--sp3x);

		--globusSVGBottom: -43%;
		--globusSVGRight: 0;
		--globusSVGHeight: 100%;

		--burgerMenuChildrenRowGap: var(--sp1-5x);
		--burgerMenuChildrenColumnGap: var(--sp1-5x);
		--burgerMenuChildGridSize: 1fr;
	}
`;

export default HeaderStyle;
